(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var triggers = document.querySelectorAll('.footer-block__accordion-trigger');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      var content = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!content) return;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        /* Only one column open at a time on mobile - close the others. */
        triggers.forEach(function (other) {
          if (other === trigger) return;
          other.setAttribute('aria-expanded', 'false');
          var otherContent = document.getElementById(other.getAttribute('aria-controls'));
          if (otherContent) otherContent.classList.remove('is-open');
        });

        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        content.classList.toggle('is-open', !isOpen);
      });
    });
  });
})();
